// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconInfo = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <path
            fill='currentcolor'
            fillRule='evenodd'
            d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-.938-5.964c0 .534.418.964.937.964s.938-.43.938-.964v-4.5a.95.95 0 0 0-.938-.965c-.52 0-.937.43-.937.965zm.937-6.75c.692 0 1.25-.575 1.25-1.286S12.691 6.714 12 6.714c-.691 0-1.25.575-1.25 1.286s.559 1.286 1.25 1.286'
            clipRule='evenodd'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconInfo)
const Memo = memo(ForwardRef)
export default Memo
